export const documentTags = {
  invoice: 'invoice',
  board: 'board',
  map: 'map',
  parkingLot: 'parkingLot',
  attachment: 'attachment',
};
